import * as React from "react";

type State = {
  selectedFilterDate: string
};

type Props = {
  setFilterDate: func
};

class DateToggle extends React.Component<Props, State> {
  state = {
    selectedFilterDate: ''
  }

  setFilterDateAllTime = () => {
    this.props.setFilterDate('');
    this.setSelectedFilterDate('all_time');
  }

  setFilterDate6MonthsAgo = () => {
    const today = new Date();
    const date = today.setMonth(today.getMonth() - 6);

    this.props.setFilterDate(date);
    this.setSelectedFilterDate('6_months_ago');
  }

  setFilterDate1YearAgo = () => {
    const today = new Date();
    const date = today.setMonth(today.getMonth() - 12);

    this.props.setFilterDate(date);
    this.setSelectedFilterDate('1_year_ago');
  }

  setSelectedFilterDate = (selectedFilterDate) => {
    this.setState({
      selectedFilterDate
    });
  }

  componentDidMount() {
    this.setFilterDateAllTime();
  }

  render() {
    const selectedFilterDate = this.state.selectedFilterDate;
    return (
      <div>
        <p>Show Institutions that haven't participated in:</p>
        <div className="btn-group btn-group-toggle" data-toggle="buttons">
          <label className={"btn btn-info " + ((selectedFilterDate === '6_months_ago') ? 'active' : '')}>
            <input
              type="radio"
              value="6_months_ago"
              onClick={this.setFilterDate6MonthsAgo}
              checked={selectedFilterDate === '6_months_ago'} />
              Past 6 Months
          </label>
          <label className={"btn btn-info " + ((selectedFilterDate === '1_year_ago') ? 'active' : '')}>
            <input
              type="radio"
              value="1_year_ago"
              onClick={this.setFilterDate1YearAgo}
              checked={selectedFilterDate === '1_year_ago'} />
              Past Year
          </label>
          <label className={"btn btn-info " + ((selectedFilterDate === 'all_time') ? 'active' : '')}>
            <input
              type="radio"
              value="all_time"
              onClick={this.setFilterDateAllTime}
              checked={selectedFilterDate === 'all_time'} />
              All Time
          </label>
        </div>
      </div>
    );
  }
};
export default DateToggle;



// WEBPACK FOOTER //
// ./app/javascript/admin_reports/institutions_not_participating/date_toggle.jsx